import { IHttpClient } from '../packages/core/http-types/src/IHttpClient';
import { ILogger } from '../packages/core/logging-types/src/logging.types';
import { IServiceProvider } from '../configuration/modules/modules.types';
import { IUserNotificationService } from '@dirootie-web/web-components-types';
import { IViewNavigator } from '@dirootie-web/web-apps-types';
import { MainAppViewStore } from '../configuration/MainAppViewStore';
import { AuthenticationService } from '../packages/domain/iam';
import { IRoutingService } from '../components-common/routes';
import { screen } from '@testing-library/react';
import { IKvpProvider } from '@dirootie-core/core-types';
import { ScreenProps } from '@components-common/types';

export interface IApplication {
  getService: <T>(name: string) => T;
  logger: ILogger;
  notifier: IUserNotificationService;
  getHttpClient: () => IHttpClient;
  routing: IRoutingService;
  navigator: IViewNavigator;
  start: () => Promise<void>;
  viewStore: MainAppViewStore;
  serviceProvider: IServiceProvider;
  getServiceProvider: () => IServiceProvider;
  screenProvider: IKvpProvider<ScreenProps>;
}

export type ApplicationOptions = {
  serviceProvider: IServiceProvider;
};

export const createApplication = (
  options: ApplicationOptions
): IApplication => {
  const getService = options.serviceProvider.resolve;

  const services = {
    getHttpClient: () => getService<IHttpClient>('http-client'),
    logger: getService<ILogger>('logger'),
    notifier: getService<IUserNotificationService>('user-notification-service'),
    getService: getService,
    navigator: getService<IViewNavigator>('navigator'),
    viewStore: getService<MainAppViewStore>('main-view-store'),
    routing: getService<IRoutingService>('routing-service'),
    authentication: getService<AuthenticationService>('authentication-service'),
    serviceProvider: options.serviceProvider,
    screenProvider: getService<IKvpProvider<ScreenProps>>('screen-provider'),
  };

  const selectEnteringPage = () => {
    return Promise.resolve();
  };

  const handleAuthenticatedUser = async (): Promise<void> => {
    return services.authentication
      .getAccountInfo(services.navigator.getCurrentUrlExcept())
      .then((x: any) => {
        services.viewStore.stopLoading();
      });
  };

  const start = async (): Promise<void> => {
    services.viewStore.startLoading();
    return selectEnteringPage().finally(() => {
      services.viewStore.stopLoading();
    });
  };

  return {
    ...services,
    getServiceProvider: () => options.serviceProvider,
    start,
  };
};
